'use client';

import dynamic from 'next/dynamic';
import { TranslationProviderWrapper } from './translation-provider-wrapper';

// Dynamically import the cookie modal to avoid hydration issues
const CookieModal = dynamic(() => import('@/components/cookie-modal'), {
  ssr: false
});
export function ClientCookieWrapper() {
  return <TranslationProviderWrapper data-sentry-element="TranslationProviderWrapper" data-sentry-component="ClientCookieWrapper" data-sentry-source-file="client-cookie-wrapper.tsx">
      <CookieModal data-sentry-element="CookieModal" data-sentry-source-file="client-cookie-wrapper.tsx" />
    </TranslationProviderWrapper>;
}